import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const CLIENTS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    CLIENTS: '/clients/',
    CLIENT_DETAIL: (id: number) => `/clients/${id}/`,
    USER: '/user/',
    ALL_CLIENTS: '/all-clients/',
    CUSTOMER_RATINGS: '/customer-ratings/',
    FINAL_STATUS: '/final-status',
    CUSTOMER_RATING_DETAIL: (id: number) => `/customer-ratings/${id}/`,
    ALL_CUSTOMER_RATINGS: '/all-customer-ratings',
  }),
} as const;
